import React from 'react';
import ImageWrapper from '../../../new-components/ImageWrapper';
import { styled } from 'styled-components';
import { useSelector } from 'react-redux';

interface NawyNowDevelopersProps {
  developer: any;
}

const NawyNowDevelopers = ({ developer }: NawyNowDevelopersProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <Container>
      <ImageWrapper
        src={developer.logoPath}
        alt={`${developer.name} Logo`}
        width={isMobile ? 60 : 80}
        height={isMobile ? 60 : 80}
        className="developer-logo"
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 32px;
  height: 100%;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  border: 0px solid transparent;

`;

export default NawyNowDevelopers;
